export interface ArrowRuleProps {
  /** Hacia donde apunta la punta de flecha. Los pares del mockup miran hacia dentro. */
  direction?: 'right' | 'left';
  className?: string;
}

/**
 * Filete dorado rematado en punta de flecha. En el mockup flanquea los kickers
 * "UN VIAJE DE DOS DÍAS" y "ENTRADAS" apuntando hacia el texto.
 */
export function ArrowRule({ direction = 'right', className }: ArrowRuleProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 8"
      width="48"
      height="8"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
      aria-hidden="true"
      focusable="false"
      style={direction === 'left' ? { transform: 'scaleX(-1)' } : undefined}
    >
      <line x1="1" y1="4" x2="43" y2="4" />
      <polyline points="39.5,1.6 43,4 39.5,6.4" />
    </svg>
  );
}
